import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core/src/metadata/di';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';

import { FuseNavigationService } from '../../../core/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service';
import { ErrorResponse } from '../../../data/model/errorResponse';
import { Exam } from '../../../data/model/exam';
import { Module } from '../../../data/model/module';
import { Organisation } from '../../../data/model/organisation';
import { Progress } from '../../../data/model/progress';
import { User } from '../../../data/model/user';
import { UserProgress } from '../../../data/model/userProgress';
import { ModulesDataManager } from '../../../data/modules.datamanager';
import { OrganisationsDataManager } from '../../../data/organisations.datamanager';
import { UsersDataManager } from '../../../data/users.datamanager';
import { ConfirmDialogComponent } from '../dialogs/confirm/confirm.dialog.component';

import { ShowExamDialogComponent } from './exam/show.exam.dialog.component';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';

@Component({
    selector: 'fuse-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
    rows: UserProgress[];
    role: string;
    name: string;
    selectedOrganisation: Organisation;
    organisationList: Organisation[];
    progressList: UserProgress[];
    userList: User[];
    moduleList: Module[];
    tempUsers: UserProgress[];
    temp = [];
    list = [];

    selectedSortingModule: any;

    constructor(
        private navigationService: FuseNavigationService, private router: Router,
        private usersDataManager: UsersDataManager,
        private modulesDataManager: ModulesDataManager,
        private organisationsDataManager: OrganisationsDataManager,
        private dialog: MatDialog, public snackBar: MatSnackBar,
        private translationLoader: FuseTranslationLoaderService) {
        this.translationLoader.loadTranslations(english, dutch);
    }

    ngOnInit() {
        this.role = localStorage.getItem('role');
        this.progressList = [];

        if (this.role !== 'superadmin') {
            this.modulesDataManager.getAllModules().subscribe((moduleRes) => {
                this.moduleList = moduleRes;

                this.usersDataManager.getAllUsers().subscribe((res) => {
                    this.userList = res;

                    this.usersDataManager.getLoggedInUser().subscribe((response) => {
                        this.organisationsDataManager
                            .getProgressByOrganisation(response.organisation)
                            .subscribe((resp) => {
                                resp.map(function(progressValue) {
                                    progressValue.userObject = res.find(function(user) {
                                        return user._id + '' ===
                                            progressValue.user;
                                    });

                                    return progressValue;
                                });

                                resp.forEach((progress, index, array) => {
                                    progress.trainings.map(function(moduleValue) {
                                        moduleValue.moduleObject = moduleRes.find(function(module) {
                                            return module._id + '' ===
                                                moduleValue._id;
                                        });
                                    });



                                    if (progress.userObject !== undefined) {
                                        this.progressList.push(progress);
                                    }

                                    if (index === array.length - 1) {
                                        this.rows = this.progressList;
                                    }
                                });

                                this.organisationsDataManager
                                    .getExamsByOrganisation(response.organisation)
                                    .subscribe((examResponse) => {
                                        this.progressList.map(function(progressValue) {
                                            let result = examResponse.find(function(examResult) {
                                                return examResult.user + '' === progressValue.user;
                                            });

                                            if (result && result.trainings) {
                                                result.trainings.forEach(function(training) {
                                                    if (!progressValue.exams) {
                                                        progressValue.exams = {};
                                                    }

                                                    if (!progressValue.exams[training._id]) {
                                                        progressValue.exams[training._id] = [];
                                                    }

                                                    progressValue.exams[training._id].push(training);
                                                });
                                            }

                                            return progressValue;
                                        });
                                    }, (err) => {
                                        this.showError(err.json());
                                    });
                            }, (err) => {
                                this.showError(err.json());
                            });
                    }, (err) => {
                        this.showError(err.json());
                    });
                }, (err) => {
                    this.showError(err.json());
                });
            }, (err) => {
                this.showError(err.json());
            });
        } else {
            this.organisationsDataManager.getAllOrganisations().subscribe((organisationRes) => {
                this.organisationList = organisationRes;
                this.selectedOrganisation = this.organisationList[0];
                this.getProgressByOrganisation();
            }, (err) => {
                this.showError(err.json());
            });
        }
    }

    getProgressByOrganisation() {
        this.name = '';
        this.progressList = [];
        this.rows = [];
        this.organisationsDataManager
            .getAllModulesByOrganisation(this.selectedOrganisation._id)
            .subscribe((moduleRes) => {
                this.moduleList = moduleRes;

                this.usersDataManager
                    .getUsersByOrganisationId(this.selectedOrganisation._id)
                    .subscribe((res) => {
                        this.userList = res;

                        this.organisationsDataManager
                            .getProgressByOrganisation(this.selectedOrganisation._id)
                            .subscribe((resp) => {
                                resp.map(function(progressValue) {
                                    progressValue.userObject =
                                        res.find(function(user) {
                                            return user._id + '' ===
                                                progressValue.user;
                                        });
                                    return progressValue;
                                });
                                resp.forEach((progress, index, array) => {
                                    progress.trainings.map(function(
                                        moduleValue) {
                                        moduleValue.moduleObject =
                                            moduleRes.find(function(module) {
                                                return module._id + '' ===
                                                    moduleValue._id;
                                            });
                                    });
                                    if (progress.userObject !== undefined) {
                                        this.progressList.push(progress);
                                    }
                                    if (index === array.length - 1) {
                                        this.rows = this.progressList;
                                    }
                                });

                                this.organisationsDataManager
                                    .getExamsByOrganisation(this.selectedOrganisation._id)
                                    .subscribe((examResponse) => {
                                        this.progressList.map(function(progressValue) {
                                            let result = examResponse.find(function(examResult) {
                                                return examResult.user + '' === progressValue.user;
                                            });

                                            if (result && result.trainings) {
                                                result.trainings.forEach(function(training) {
                                                    if (!progressValue.exams) {
                                                        progressValue.exams = {};
                                                    }

                                                    if (!progressValue.exams[training._id]) {
                                                        progressValue.exams[training._id] = [];
                                                    }

                                                    progressValue.exams[training._id].push(training);
                                                });
                                            }

                                            return progressValue;
                                        });
                                    }, (err) => {
                                        this.showError(err.json());
                                    });
                            }, (err) => {
                                this.showError(err.json());
                            });
                    }, (err) => {
                        this.showError(err.json());
                    });
            }, (err) => {
                this.showError(err.json());
            });
    }

    getProgressByModule(progressList: Progress[], moduleId: string): Progress {
        let prog = null;

        progressList.forEach(progress => {
            if (progress._id === moduleId) {
                prog = progress;
            }
        });

        return prog;
    }

    getExamsByModule(examList: Exam[], moduleId: string): Exam[] {
        if (examList !== undefined && examList !== null) {
            const ex: Exam[] = null;
            examList.forEach(exam => {
                if (exam._id === moduleId) {
                    ex.push(exam);
                }
            });
            return ex;
        } else {
            return null;
        }
    }

    getHighestExamByModule(examList: any, moduleId: string): Exam {
        if (!examList || !examList[moduleId] || examList[moduleId] <= 0) {
            return undefined;
        }
        let exam: Exam;

        examList[moduleId].forEach(lExam => {
            if (!exam) {
                exam = lExam;
            } else {
                if (lExam.percentage_correct > exam.percentage_correct) {
                    exam = lExam;
                }
            }
        });

        return exam;
    }

    getUserById(id: String): User {
        let u = null;
        this.userList.forEach(user => {
            if (id === user._id) {
                u = user;
            }
        });
        return u;
    }

    showExamButtonClick(rowIndex: number, module: Module) {
        const progress: UserProgress = this.rows[rowIndex];

        // const exams = this.getExamsByModule(this.rows[rowIndex].exams, moduleId);
        // const exams: Exam[] = new Array<Exam>();

        // progress.trainings.forEach(training => {
        //   if (training.moduleObject !== null &&
        //       training.moduleObject !== undefined &&
        //       training.percentage_completed > 0) {
        //     const passed = training.percentage_completed > 50 ? true : false;
        //     const exam: Exam = new Exam({
        //       organisation: this.selectedOrganisation,
        //       module: training.moduleObject,
        //       user: progress.userObject,
        //       has_passed: passed,
        //       percentage_correct: training.percentage_completed
        //     });
        //     exams.push(exam);
        //   }
        // });

        const dialogRef = this.dialog.open(ShowExamDialogComponent, {
            height: '830px',
            width: '800px',
            data: {
                exams: progress.exams[module._id],
                organisation: this.selectedOrganisation,
                module: module,
                user: progress.userObject
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== null && result !== undefined) {
                if (typeof result === 'string') {
                    this.showMessage(result);
                    this.ngOnInit();
                } else {
                    this.showError(result);
                }
            }
        });
    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();

        // filter our data
        const temp = this.progressList.filter(function(d) {
            return d.userObject.name.toLowerCase().indexOf(val) !== -1 || d.userObject.email.toLowerCase().indexOf(val) !== -1 || !val;
        });

        // update the rows
        this.rows = temp;
    }

    onSort(event) {
        let module = this.moduleList.find(module => {
            return event.column.prop === module._id;
        });

        if (!module) {
            this.rows = this.rows.sort((a, b) => {
                let valueA = a;
                let valueB = b;

                event.column.prop.split('.').forEach(prop => {
                    valueA = valueA[prop];
                    valueB = valueB[prop];
                });

                if (event.newValue === 'desc') {
                    if (valueA > valueB) {
                        return 1;
                    }
                    if (valueB > valueA) {
                        return -1;
                    }
                    return 0;
                } else if (event.newValue === 'asc') {
                    if (valueA > valueB) {
                        return -1;
                    }
                    if (valueB > valueA) {
                        return 1;
                    }
                    return 0;
                }
                return 0;
            });
            return;
        }

        if (module.is_exam) {
            this.rows = this.rows.sort((a, b) => {
                let highestExamA = this.getHighestExamByModule(a.exams, module._id);
                let highestExamB = this.getHighestExamByModule(b.exams, module._id);

                if (event.newValue === 'desc') {
                    if (!highestExamA && highestExamB) {
                        return 1;
                    } else if (highestExamA && !highestExamB) {
                        return -1;
                    } else if (highestExamA && highestExamB) {
                        return <any>highestExamB.percentage_correct - <any>highestExamA.percentage_correct;
                    } else {
                        return 0;
                    }
                } else if (event.newValue === 'asc') {
                    if (!highestExamA && highestExamB) {
                        return -1;
                    } else if (highestExamA && !highestExamB) {
                        return 1;
                    } else if (highestExamA && highestExamB) {
                        return <any>highestExamA.percentage_correct - <any>highestExamB.percentage_correct;
                    } else {
                        return 0;
                    }
                }
                return 0;
            });
        } else {
            this.rows = this.rows.sort((a, b) => {
                let progressA = this.getProgressByModule(a.trainings, module._id);
                let progressB = this.getProgressByModule(b.trainings, module._id);

                if (event.newValue === 'desc') {
                    if (!progressA && progressB) {
                        return 1;
                    } else if (progressA && !progressB) {
                        return -1;
                    } else if (progressA && progressB) {
                        return progressB.percentage_completed - progressA.percentage_completed;
                    } else {
                        return 0;
                    }
                } else if (event.newValue === 'asc') {
                    if (!progressA && progressB) {
                        return -1;
                    } else if (progressA && !progressB) {
                        return 1;
                    } else if (progressA && progressB) {
                        return progressA.percentage_completed - progressB.percentage_completed;
                    } else {
                        return 0;
                    }
                }
                return 0;
            });
        }
    }

    showMessage(message: string) {
        this.snackBar.open(message, null, { duration: 5000 });
    }

    showError(message: ErrorResponse) {
        if (message.errors !== null && message.errors !== undefined &&
            message.errors.length > 0) {
            this.snackBar.open(message.errors[0].message, null, { duration: 10000 });
        } else {
            this.snackBar.open('Unknown error occured', null, { duration: 10000 });
        }
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/progress/progress.component.ts